import React from 'react'
import { FoundationsConstants } from './FoundationsConstants'
declare let window: any
const UnicornApp = window.unicornInstance as any
import axios, { AxiosResponse, AxiosRequestConfig, AxiosError } from 'axios'

export function getBaseUrl() {
    return FoundationsConstants.BASE_URL
}

interface axiosProps {
    url: string
    data?: Object
    context?: Object
    success?: Function
    error?: Function
    beforeSend?: Function
    cache?: boolean
    triggerEvents?: {
        Started: boolean | String
        EndedSuccesfully: boolean | String
        EndedWithFailure: boolean | String
    }
    includeTokenHeader?: boolean
    Started?: Boolean
}

const axiosApi = axios.create({
    baseURL: getBaseUrl(),
})

const requestInterceptor = (config: AxiosRequestConfig) => {
    config.headers['Content-Type'] = 'application/json; charset=utf-8'
    return config
}
axiosApi.interceptors.request.use(requestInterceptor)

export async function FoundationsRequest(
    type: 'GET' | 'POST' | 'PUT' | 'DELTE',
    options: axiosProps
) {
    var originalSuccess = options.success
    var originalError = options.error
    var triggerEvents = options.triggerEvents

    if (UnicornApp.userFeedbackChannel) {
        UnicornApp.userFeedbackChannel.trigger(
            (triggerEvents && triggerEvents.Started) || 'HLModel:FetchStarted',
            {
                context: options.context,
            }
        )
    }

    const hl_user_token = options?.includeTokenHeader ? UnicornApp.getUserHLToken() : null

    let axiosHeaders: any = options.cache
        ? {
              'Cache-Control': 'no-cache',
              Pragma: 'no-cache',
              Expires: '0',
          }
        : {}

    if (hl_user_token !== null) axiosHeaders[FoundationsConstants.TOKEN_STR] = hl_user_token

    try {
        if (options.beforeSend !== undefined) options.beforeSend()
        const response: AxiosResponse =
            type === 'POST'
                ? await axiosApi.post(options.url, options.data, {
                      headers: axiosHeaders,
                  })
                : await axiosApi.get(options.url, {
                      headers: axiosHeaders,
                  })

        const data = await response.data
        if (UnicornApp.userFeedbackChannel) {
            UnicornApp.userFeedbackChannel.trigger(
                (triggerEvents && triggerEvents.EndedSuccesfully) ||
                    'UnicornRequest:EndedSuccesfully',
                {
                    data: data,
                    textstatus: response.statusText,
                    context: options.context,
                }
            )
        }
        if (originalSuccess !== undefined) {
            originalSuccess(data, response.statusText)
        }
    } catch (error) {
        const axiosError = error as AxiosError
        if (UnicornApp.userFeedbackChannel) {
            UnicornApp.userFeedbackChannel.trigger(
                (triggerEvents && triggerEvents.EndedWithFailure) ||
                    'UnicornRequest:EndedWithFailure',
                {
                    textStatus: axiosError.response?.statusText,
                    errorThrown: axiosError,
                    context: options.context,
                }
            )
        }

        if (originalError !== undefined) {
            originalError(axiosError.response?.statusText, axiosError)
        }
    }
}

export async function handleHardReload(url: string) {
    await fetch(url, {
        headers: {
            Pragma: 'no-cache',
            Expires: '-1',
            'Cache-Control': 'no-cache',
        },
    })
    window.location.href = url
    window.location.reload()
}

//TODO1 : handle getting user object and saving in redux store globally
// public getCurrentUserFromAPI(forceFetch = false): JQuery.Deferred<any, any, any> {
//     var __this = this;
//     var defer = $.Deferred();
//     if (forceFetch) {
//       var me = new Me({ app: __this });

//       var myPromise = me.fetch({
//         success: function (response) {
//           if (response != null) {
//             var resultData = response.data;
//             if (resultData != null) {
//               if (resultData.MessageResults.length > 0) {
//                 for (var i = 0; i < resultData.MessageResults.length; i++) {
//                   if (resultData.MessageResults[i].HelpMessage == FoundationsEnums.Status.Success) {
//                     __this.toastr("success", resultData.MessageResults[i].Message);
//                   } else {
//                     __this.toastr("error", resultData.MessageResults[i].Message);
//                   }
//                 }
//               } else {
//                 __this.toastr("error", "Something went wrong");
//               }
//             }
//           }
//         },
//         error: function (err) {
//           console.log("error on fetching current user");
//           defer.reject(err);

//           //__this.redirectToSignIn();

//         },

//       });

//       myPromise.then(function (res) {
//         // __this.session.extendCookieTime("AuthToken"); // extend cookie session.

//         __this.globals.me = me;
//         defer.resolve(me);
//         __this.meState = "loaded";
//       });

//     } else {
//       if (this.meState != "loaded" && this.meState != "failed") {
//         if (this.meState != "loading") {
//           this.meState = "loading";
//           var me = new Me({ app: __this });

//           var myPromise = me.fetch({
//             success: function (response) {
//               if (response != null) {
//                 var resultData = response.attributes;
//                 if (resultData != null) {
//                   if (resultData.MessageResults.length > 0) {
//                     for (var i = 0; i < resultData.MessageResults.length; i++) {
//                       if (resultData.MessageResults[i].HelpMessage == FoundationsEnums.Status.Success) {

//                       } else {
//                         __this.toastr("error", resultData.MessageResults[i].Message)
//                       }
//                     }
//                   } else {
//                     this.toastr("error", "Something went wrong")
//                   }
//                 }
//               }
//             },
//             error: function (err) {
//               console.log("error on fetching current user");
//               defer.reject(err);

//               //__this.redirectToSignIn();

//             },

//           });

//           myPromise.then(function (res) {
//             // __this.session.extendCookieTime("AuthToken"); // extend cookie session.

//             __this.globals.me = me;
//             __this.meState = "loaded";
//             while (__this.mePromises.length) {
//               let d = __this.mePromises.pop();
//               d && d.resolve(me);
//             }
//           }, _ => {
//             __this.meState = "failed";
//             while (__this.mePromises.length) {
//               let d = __this.mePromises.pop();
//               d && d.reject();
//             }
//           });
//         }
//         this.mePromises.push(defer);
//         return defer;
//       } else if (this.meState == "loaded") {
//         setTimeout(function () {
//           //TODO! the issue is that this.globals.me should be cleared on sign out, or mestate should not be loaded
//           if (__this.globals.me)
//             defer.resolve(__this.globals.me);
//           else
//             defer.reject();
//         }, 0);
//       } else if (this.meState == "failed") {
//         setTimeout(function () {
//           defer.reject();
//         }, 0);
//       }
//     }

//     return defer;
//   }

// TODO 2 handle getting app settings nad storing globally in redux store

//   public getAppSettings(forceFetch = false): JQuery.Deferred<any, any, any> {
//     //Explanation to the code...
//     //We want to ensure only single call to Settings API, even though multiple handles may want to lay claim to the respurce.
//     //Of course, 'force' call is an exception.
//     //So, we maintain state of Settings API. If State is
//     // 1. 'just-start-of-page-load': make calls, but set the state to loading.
//     // 2. 'loading': then do nothing. By default, all promises are enqueued. Once finished fetching, reolve (or reject) everything in queue.
//     // 3. 'loaded': resolved with this.global.settings
//     // 4. 'failed': reject all promises
//     //I have unit tested this with a dozen simultaneous calls. For sure, only 1 request goes on wire.
//     //This is loosely based on logic for 'me' API, but this  is much cleaner. So, we should rewrite 'me' in this clean way.
//     //Also, if we are going to do this a lot, lets support it as a part of framework.
//     let defer = $.Deferred();
//     let __this = this;

//     if (forceFetch) {
//       let publicAppSettings = new PublicAppModel({ app: __this });

//       publicAppSettings.fetch().then(function (publicAppSettingsResponse) {
//         let privateAppSettings = new ProtectedAppModel({ app: __this });
//         if (__this.globals?.me || __this.getUserHLToken()) {
//           privateAppSettings.fetch().then(privateAppSettingsResponse => {
//             __this.globals.appSettings = new AppModel({ app: __this });
//             __this.globals.appSettings.set({ ...publicAppSettingsResponse.data, ...privateAppSettingsResponse.data });
//             if (window.healthLevelGlobal) {
//               window.healthLevelGlobal.appSettings = __this.globals.appSettings.toJSON();
//             }
//             __this.resolveAllPromises(__this.settingsPromises, __this.globals.appSettings);

//             this.settingsState = "loaded";
//           })
//         } else {
//           __this.globals.appSettings = new AppModel({ app: __this });
//           __this.globals.appSettings.set(publicAppSettingsResponse.data);

//           if (window.healthLevelGlobal) {
//             window.healthLevelGlobal.appSettings = __this.globals.appSettings.toJSON();
//           }

//           __this.resolveAllPromises(__this.settingsPromises, __this.globals.appSettings);
//           this.settingsState = "loaded";
//         }

//       }, (err) => {
//         __this.clearUserSessionAndRedirect()
//         console.log("error on fetching app settings");
//         __this.rejectAllPromises(__this.settingsPromises, err);
//       });

//     } else {
//       if (__this.settingsState == "loaded") {
//         setTimeout(function () {
//           __this.resolveAllPromises(__this.settingsPromises, __this.globals.appSettings);
//         }, 0);
//       } else if (__this.settingsState == "failed") {
//         __this.rejectAllPromises(__this.settingsPromises, undefined);
//       } else if (__this.settingsState == "loading") {
//       } else {
//         __this.settingsState = "loading";

//         let publicAppSettings = new PublicAppModel({ app: __this });

//         publicAppSettings.fetch().then(function (publicAppSettingsResponse) {
//           let privateAppSettings = new ProtectedAppModel({ app: __this });
//           if (__this.globals?.me || __this.getUserHLToken()) {
//             privateAppSettings.fetch().then(privateAppSettingsResponse => {
//               __this.globals.appSettings = new AppModel({ app: __this });
//               __this.globals.appSettings.set({ ...publicAppSettingsResponse.data, ...privateAppSettingsResponse.data });
//               if (window.healthLevelGlobal) {
//                 window.healthLevelGlobal.appSettings = __this.globals.appSettings.toJSON();
//               }
//               __this.resolveAllPromises(__this.settingsPromises, __this.globals.appSettings);

//               __this.settingsState = "loaded";
//             })
//           } else {
//             __this.globals.appSettings = new AppModel({ app: __this });
//             __this.globals.appSettings.set(publicAppSettingsResponse.data);

//             if (window.healthLevelGlobal) {
//               window.healthLevelGlobal.appSettings = __this.globals.appSettings.toJSON();
//             }

//             __this.resolveAllPromises(__this.settingsPromises, __this.globals.appSettings);
//             __this.settingsState = "loaded";
//           }

//         }, (err) => {
//           __this.clearUserSessionAndRedirect()
//           console.log("error on fetching app settings");
//           __this.rejectAllPromises(__this.settingsPromises, err);
//           __this.settingsState = "failed";
//         });
//       }

//     }
//     __this.settingsPromises.push(defer);
//     return defer;
//   }

// TODO3 handle toastr messages in react

// toastr(type: 'success' | 'error' | 'clear' | 'warning' = 'success', message = '', option: any = {}) {
//     (<any>window.toastr).options = {
//       preventDuplicates: option.preventDuplicates || true,
//       closeButton: option.closeButton || false,
//       newestOnTop: option.newestOnTop || false,
//       progressBar: option.progressBar || false,
//       positionClass: option.positionClass || "toast-bottom-right",
//       onclick: option.onclick || null,
//       showDuration: option.showDuration || 300,
//       hideDuration: option.hideDuration || 2000,
//       timeOut: option.timeOut != undefined ? option.timeOut : 2500,
//       extendedTimeOut: option.extendedTimeOut != undefined ? option.extendedTimeOut : 1000,
//       showEasing: option.showEasing || "swing",
//       hideEasing: option.hideEasing || "linear",
//       showMethod: option.showMethod || "fadeIn",
//       hideMethod: option.hideMethod || "fadeOut",
//     };
//     var currentToast;
//     if (type === 'clear') {
//       this.countdownToastrShown = false;
//       currentToast = (<any>window.toastr)[type]();
//     } else {
//       currentToast = (<any>window.toastr)[type](message);
//     }
//     return currentToast;
//   }

interface OpenIDParams {
    setPageError?: (msg: string) => void;
    setOpenIdLoading?: (loading: boolean) => void;
    setRequestSent?: (sent: boolean) => void;
}

export const handleSSOSignIn = ({
    setPageError,
    setOpenIdLoading,
    setRequestSent,
}: OpenIDParams = {}) => {
    setPageError?.('');
    setOpenIdLoading?.(true);
    setRequestSent?.(true);
    
    FoundationsRequest('GET', {
        url: 'api/v3/account/SSOLogin',
        cache: false,
        success: function (response: { data: any } | null) {
            if (response != null) {
                const authRequest = response.data;
                if (authRequest != null) {
                    const openIDURL =
                        authRequest.OpenIdLoginURL +
                        authRequest.OpenIdRedirectURL +
                        '&scope=' +
                        authRequest.scope +
                        '&client_id=' +
                        authRequest.client_id +
                        '&state=' +
                        authRequest.state;

                    UnicornApp.setCookie(
                        FoundationsConstants.OPENID_STATE,
                        authRequest.state,
                        10
                    );

                    window.location.href = openIDURL;
                }
            }
        },
        error: function (
            request: { responseJSON: { hints: any; statusMessage: any } },
            err: any
        ) {
            setPageError?.(
                request.responseJSON?.hints ??
                request.responseJSON?.statusMessage ??
                'An error occurred during SSO.'
            );
            setOpenIdLoading?.(false);
            setRequestSent?.(false);
        },
    });
};
